import { StyleSheet } from 'react-native';

export default StyleSheet.create({
  containerStyle: keyboardHeight => ({
    marginTop: 25,
    paddingBottom: keyboardHeight,
  }),
  headerStyle: {
    marginTop: 12,
    marginHorizontal: 0,
    alignItems: 'center',
  },
});
